module.exports = __webpack_public_path__ + "img/settings.b4d17a36.svg";